import angular from "angular";

angular
	.module('app')
	.component('quizResultsControl', {
		template: require('./quiz-results-control.html'),
        controller: ['$http', '$uibModal', controller],
        bindings: {
            'courses': '<'
        }
    });
            
function controller($http, $uibModal) {

	let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.course = null;
    $ctrl.lesson = null;
    $ctrl.user = null;
    $ctrl.status = null;
    $ctrl.perPage = '15';
    $ctrl.orderBy = 'id';
    $ctrl.orderDir = 'desc';

    $ctrl.$onInit = function () {
        $ctrl.getResults();
    };

    $ctrl.getResults = function () {
        $http
            .get('/admin/results/get-list', {
                params: {
                    page: $ctrl.page,
                    user_id: $ctrl.user ? $ctrl.user.id : null,
                    course_id: $ctrl.course ? $ctrl.course.id : null,
                    lesson_id: $ctrl.lesson ? $ctrl.lesson.id : null,
                    status: $ctrl.status ? $ctrl.status : null,
                    order_by: $ctrl.orderBy,
                    order_dir: $ctrl.orderDir,
                    per_page: $ctrl.perPage,
                }
            })
            .then(
                function (response) {
                    $ctrl.quizzes = response.data.data;
                    $ctrl.total = response.data.total;
                },
                function (error) {

                }
            );
    };

    $ctrl.reset = function () {
        $ctrl.page = 1;
        $ctrl.course = null;
        $ctrl.lesson = null;
        $ctrl.user = null;
        $ctrl.status = null;
        $ctrl.getResults();
    };

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getResults();
    };

    $ctrl.setOrderBy = function (orderBy) {
        if ($ctrl.orderBy == orderBy) {
            $ctrl.orderDir = $ctrl.orderDir == 'asc' ? 'desc' : 'asc';
        } else {
            $ctrl.orderBy = orderBy;
            $ctrl.orderDir = 'asc';
        }
        $ctrl.page = 1;
        $ctrl.getResults();
    };

    $ctrl.categoryChanged = function () {
        $ctrl.lesson = null;
    };

    $ctrl.getUsers = function (fragment) {
        return $http
            .get('/admin/users/get-by-fragment', {params: {fragment}})
            .then(
                function (response) {
                    return response.data.users;
                }
            )
    };

    $ctrl.openQuizResult = function (questions) {
        $uibModal
            .open({
                component: 'quizResultAdminPage',
                resolve: {
                    questions: function () {
                        return questions;
                    }
                },
                backdrop: 'static',
                size: 'lg'
            })
    };

    $ctrl.checked = function (quiz) {
        console.log(quiz);
        $http
            .post(`/admin/quiz/${quiz.id}/checked`)
            .then(
                function (response) {
                    quiz.is_checked = true;
                },
                function (error) {
                }
            );
    };
}